/// <amd-module name="InstantSearch/Shared/TelemetryWriter" />

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssPerformanceService, IVssScenario } from "VSS/Platform/Performance";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { CustomerIntelligenceConstants } from "InstantSearch/Shared/Constants";
import { getSetting } from "InstantSearch/Shared/Utils";

const ExcludeTelemetrySettingKey = "Search/Telemetry/ExcludeMarkingTTI"; // set it on TFS as /Configuration/Settings/Host/Search/Telemetry/ExcludeMarkingTTI at collection host level.

/**
 * Writes telemetry events for work item search suggestions.
 */
export class TelemetryWriter {
    private _ttiMarked: boolean;
    private _excludeMarkingTTI: boolean;

    constructor(
        private pageContext: IVssPageContext,
        private feature: string
    ) {
        this._ttiMarked = false;
        this._excludeMarkingTTI = getSetting<boolean>(this.pageContext, ExcludeTelemetrySettingKey, false);
    }

    public publish = (event: string, extraProperties: { [key: string]: any } = {}): void => {
        const telemetryService: IVssTelemetryService = this.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        telemetryService.publishEvent(CustomerIntelligenceConstants.Area, this.feature, { ...extraProperties, event: event });
    };

    public notifySearchStarted = (eventName: string, ttiSearchScenarioName: string, subSequentSearchScenarioName: string): IVssScenario => {
        let scenario: IVssScenario;
        const properties = {
            featureName: this.feature,
            eventName: eventName,
            isExcludedFromTTI: this._excludeMarkingTTI
        };
        if (this._ttiMarked) {
            scenario = this.service.startScenario(subSequentSearchScenarioName, !this._excludeMarkingTTI, undefined, properties);
        } else {
            scenario = this.service.startScenario(ttiSearchScenarioName, !this._excludeMarkingTTI, undefined, properties);
        }

        scenario.featureArea = CustomerIntelligenceConstants.FeatureArea;

        return scenario;
    };

    public notifySearchFailed = (scenario: IVssScenario, error: any): void => {
        scenario.addProperties({ isAborted: true, error: error });
        scenario.complete();

        if (!this._ttiMarked) {
            this._ttiMarked = true;
        }
    };

    public notifyResultsRendered = (scenario: IVssScenario): void => {
        scenario.complete();

        if (!this._ttiMarked) {
            this._ttiMarked = true;
        }
    };

    private get service(): IVssPerformanceService {
        return this.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    }
}
